module.exports = __webpack_public_path__ + "media/rusted-promo.a51add55.mp4";